import { Avatar, Grid, Typography } from "@mui/material";
import React from "react";

import { generateAvatar } from "app/utils/avatar";
import DoctorChart from "components/pages/dashboard/doctor_analytic/chart/DoctorChart";

const Doctor = ({ name, report }) => {
  return (
    <Grid container item display="flex">
      <Grid
        item
        md={2}
        sm={2}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ paddingLeft: "0px !important" }}
      >
        <Avatar sx={{ width: 50, height: 50, fontSize: "0.875rem" }}>
          {generateAvatar(name)}
        </Avatar>
        <Typography
          variant="h6"
          sx={{ fontSize: "0.875rem", fontWeight: 400 }}
          align="center"
        >
          {name}
        </Typography>
      </Grid>
      <Grid item md={10} sm={10}>
        <DoctorChart data={report} />
      </Grid>
    </Grid>
  );
};

export default Doctor;
